import React from "react";
import { Form, FormGroup, Input, Label } from "reactstrap";
import styles from "../InvoicesComponents.module.scss";

export default function DischargeFormComponent(props) {
  const {
    onInputChange,
    dischargeAmountBuilding,
    setDischargeAmountBuilding,
    discountedElectricityRateBuilding,
    setDiscountedElectricityRateBuilding,
  } = props;
  return (
    <div>
      <Form className={styles.Form}>
        <FormGroup className={styles.FormGroup}>
          <div className={styles.FormInputContainer}>
            <Label>Discharge Amount (kWh)</Label>
            <Input
              type="number"
              value={dischargeAmountBuilding}
              onChange={(e) => onInputChange(e, setDischargeAmountBuilding)}
              step={0.01}
            />
          </div>
          <div className={styles.FormInputContainer}>
            <Label>Discounted Rate ($/kWh)</Label>
            <Input
              type="number"
              value={discountedElectricityRateBuilding}
              onChange={(e) =>
                onInputChange(e, setDiscountedElectricityRateBuilding)
              }
              step={0.001}
            />
          </div>
        </FormGroup>
      </Form>
    </div>
  );
}
